import Workspace from './Workspace';
import { useUserWorkspaceAccessSummary } from './accessSummary/getUserWorkspaceAccessSummary';

export function RestrictedWorkspace() {
  const { displayName, displayBoardCount } = useUserWorkspaceAccessSummary()
  return <Workspace name={displayName} boardCount={displayBoardCount ?? 0} />;
}
